import axios from 'axios'
import { axiosWithRetries } from './axios-retry'

export const getLeadByUuid = async (uuid) => {
  return axios.get(`/api/lead/${uuid}`).then((res) => res.data)
}

export const getLeadById = async (id) => {
  return axios.get(`/api/lead?id=${id}`).then((res) => res.data)
}

export const updateLeadContactInformation = async (lead) => {
  return axios.put(`/api/lead/${lead.id}`, lead).then((res) => res.data)
}

export const getLeadHistory = async (id) => {
  return axios.get(`/api/lead/${id}/history`).then((res) => res.data)
}

export const findLeadToProcess = async () => {
  return axiosWithRetries({
    method: 'post',
    url: '/api/lead/find-lead-to-process',
  }).then((res) => res.data)
}

export const getRandomLead = async (missionId) => {
  return axios.get(`/api/lead/random/${missionId}`).then((res) => res.data)
}

export const getUserViewingLead = async (userId) => {
  return axios.get(`/api/lead/user/${userId}`).then((res) => res.data)
}

export const searchLeads = async ({ search, page, limit, missionId }) => {
  return axios.get(`/api/lead/search/${search}/${page}?limit=${limit}${missionId ? `&missionId=${missionId}` : ''}`).then((res) => {
    return res.data
  })
}

export const linkCallToLead = async ({ leadId, callId }) => {
  return axios.post(`/api/call/${callId}/link-lead/${leadId}`).then((res) => res.data)
}

export const pickLeadFromSearch = async ({ leadId }) => {
  return axios.post(`/api/lead/search/pick/${leadId}`).then((res) => res.data)
}

export const updateLeadComment = async ({ leadId, comment }) => {
  return axios.put(`/api/lead/${leadId}/comment`, { comment }).then((res) => res.data)
}

export const getLeadAppointmentAvailabilities = async ({ leadId }) => {
  return axios.get(`/api/lead/${leadId}/appointment-availabilities`).then((res) => res.data)
}

export const makeAppointment = async ({ leadId, appointment }) => {
  return axios.post(`/api/lead/${leadId}/appointment`, appointment).then((res) => res.data)
}

export const updateLeadAndLeadTag = async ({
  leadId,
  leadTagId,
  callProcessTagId,
  step,
  status,
  substatus,
}) => {
  return axios.put(`/api/lead/${leadId}/lead-tag/${leadTagId}`, {
    callProcessTagId,
    step,
    status,
    substatus,
  }).then((res) => res.data)
}

export const transferLeadsToLocation = async ({ locationId, marketCode, file }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('marketCode', marketCode)
  formData.append('locationId', locationId)
  return axios.post(`/api/leads/transfer-leads`, formData).then((res) => res.data)
}


export default {
  getLeadByUuid,
  getLeadById,
  updateLeadContactInformation,
  getLeadHistory,
  findLeadToProcess,
  getRandomLead,
  getUserViewingLead,
  searchLeads,
  linkCallToLead,
  pickLeadFromSearch,
  updateLeadComment,
  getLeadAppointmentAvailabilities,
  makeAppointment,
}
